import axios from "axios";

import { IPeriodLevel } from "backend/model/model";
// import { KPIValues } from "./KPIsForm/index.dto";
import { KPIValues } from "./KPIsForm/index.dto";
import { mapKpiToWorkflow } from "./dataMapping/dataMapperKPI";

const initiateMapping = async (
  values: KPIValues,
  meaId: string,
  periodlevels: IPeriodLevel[] | undefined
) => {
  const data = mapKpiToWorkflow(values, periodlevels || [], meaId);
  console.log("data before mapping: ", values);
  console.log("data after mapping:", data);
  return data;
};

export const ApproveKPIForm = async (
  wfid: string,
  values: KPIValues,
  formType: string,
  role: string,
  periodlevels: IPeriodLevel[],
  initialValues: KPIValues,
  allowedit: boolean,
  meaId: string
) => {
  if (!allowedit || initialValues === values) {
    const res = await axios
      .put(`workflow/instances/${wfid}`, {
        transition: "APPROVE",
      })
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err;
      });
    return res;
  }

  const data = mapKpiToWorkflow(values, periodlevels, meaId);

  const res = await axios
    .put(`workflow/instances/${wfid}`, {
      transition: "APPROVE",
      parameters: data.parameters,
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err;
    });
  return res;
};

export const RejectKPIForm = async (wfid: string) => {
  const res = await axios
    .put(`workflow/instances/${wfid}`, {
      transition: "REJECT",
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err;
    });
  return res;
};

const SubmitKPIForm = async (
  values: KPIValues,
  formType: string,
  role: string,
  wfid: string,
  meaId: string,
  periodlevels: IPeriodLevel[],
  isAdmin: boolean
): Promise<{ status: string; wfid?: string | undefined }> => {
  if (formType !== "KPI") return { status: "fail" }; // not supported yet

  const data = mapKpiToWorkflow(values, periodlevels, meaId);

  const res = wfid
    ? await axios
        .put(`workflow/instances/${wfid}`, {
          transition: "SUBMIT",
          parameters: data.parameters,
        })
        .then((result) => result)
        .catch((err) => err.response)
    : await axios
        .post(isAdmin ? "workflow/directupdate" : "workflow/instances", {
          ...data,
          elementType: formType,
        })
        .then((result) => result)
        .catch((err) => {
          return err.response?.data;
        });
  const { message } = res;

  if (res.status === 201 || res.status === 200) {
    return {
      status: "success",
      wfid: res.data?.data?.wfInstanceId || "",
    };
  }

  if (message.includes("already exists")) {
    return {
      status: "failExists",
    };
  }
  return {
    status: "fail",
  };
};

export default SubmitKPIForm;
